export const bulidFilterWorkReportRequest = ({ filters, paginationData, isPending }) => {
  const filtersWorkReport = {
    equipos: filters?.equipo
      ? filters.equipo.map((equip) => ({
          id: equip.id,
          nombre: equip.nombre
        }))
      : [],
    servicios: filters?.idsServicios
      ? filters.idsServicios.map((servicio) => ({
          id: servicio.id,
          nombre: servicio.nombre
        }))
      : [],
    proveedores: filters.idsProveedores
      ? filters.idsProveedores.map((proveedor) => ({
          id: proveedor.id,
          nombre: proveedor.nombre
        }))
      : [],
    tipoEvento: filters.evento?.length
      ? filters.evento.map((evento) => ({
          id: evento.id,
          nombre: evento.nombre
        }))
      : [],
    tipoUbicacionEnum: filters?.tipoUbicacionEnum
      ? {
          id: filters?.tipoUbicacionEnum.id,
          nombre: filters?.tipoUbicacionEnum.nombre
        }
      : null,
    ubicaciones: filters?.ubicacion
      ? filters.ubicacion.map((ubicacion) => ({
          id: ubicacion.id,
          nombre: ubicacion.nombre
        }))
      : [],
    unidadNegocio: filters?.unidadesNegocioIds
      ? filters?.unidadesNegocioIds.map((unidad) => ({
          id: unidad.id,
          nombre: unidad.nombre
        }))
      : [],
    unidadesNegocio: filters?.unidadesNegocioIds
      ? filters?.unidadesNegocioIds.map((unidad) => ({
          id: unidad.id,
          nombre: unidad.nombre
        }))
      : [],
    operaciones: filters?.operacionesIds
      ? filters.operacionesIds.map((operacion) => ({
          id: operacion.id,
          nombre: operacion.nombre
        }))
      : [],
    contratos: filters?.idsContratos?.length
      ? filters?.idsContratos.map((contrato) => ({ id: contrato.id, nombre: contrato.nombre }))
      : [],
    numerosSolicitudes: filters.numeroSolicitud?.length
      ? filters.numeroSolicitud.map((req) => ({
          id: req.id,
          nombre: req.nombre,
          tipoAsignacion: req.tipoAsignacion
        }))
      : [],
    posicionesLineas:
      filters?.posicionesLineas?.map((positionLine) => positionLine?.value.replace(/[PL]/g, '')) ??
      [],
    estadosSolicitud:
      !isPending && filters?.estadosSolicitud?.length
        ? filters?.estadosSolicitud.map((state) => ({
            id: state.id,
            nombre: state.nombre
          }))
        : [],
    pagination: {
      pageNumber: paginationData.pageNumber,
      pageSize: paginationData.pageSize
    },
    agrupaPorUbicacion: paginationData.agrupaPorUbicacion
  };

  return {
    filters: filtersWorkReport
  };
};

export const bulidFilterWorkReportRequestNoPage = ({ filters, isPending }) => {
  const filtersWorkReport = {
    equipos: filters?.equipo
      ? filters.equipo.map((equip) => ({
          id: equip.id,
          nombre: equip.nombre
        }))
      : [],
    servicios: filters?.idsServicios
      ? filters.idsServicios.map((servicio) => ({
          id: servicio.id,
          nombre: servicio.nombre
        }))
      : [],
    proveedores: filters.idsProveedores
      ? filters.idsProveedores.map((proveedor) => ({
          id: proveedor.id,
          nombre: proveedor.nombre
        }))
      : [],
    tipoEvento: filters.evento?.length
      ? filters.evento.map((evento) => ({
          id: evento.id,
          nombre: evento.nombre
        }))
      : [],
    tipoUbicacionEnum: filters?.tipoUbicacionEnum
      ? {
          id: filters?.tipoUbicacionEnum.id,
          nombre: filters?.tipoUbicacionEnum.nombre
        }
      : null,
    ubicaciones: filters?.ubicacion
      ? filters.ubicacion.map((ubicacion) => ({
          id: ubicacion.id,
          nombre: ubicacion.nombre
        }))
      : [],
    unidadNegocio: filters?.unidadesNegocioIds
      ? filters?.unidadesNegocioIds.map((unidad) => ({
          id: unidad.id,
          nombre: unidad.nombre
        }))
      : [],
    unidadesNegocio: filters?.unidadesNegocioIds
      ? filters?.unidadesNegocioIds.map((unidad) => ({
          id: unidad.id,
          nombre: unidad.nombre
        }))
      : [],
    operaciones: filters.operacionesIds
      ? filters.operacionesIds.map((operacion) => ({
          id: operacion.id,
          nombre: operacion.nombre
        }))
      : [],
    contratos: filters?.idsContratos?.length
      ? filters?.idsContratos.map((contrato) => ({ id: contrato.id, nombre: contrato.nombre }))
      : [],
    numerosSolicitudes: filters.numeroSolicitud?.length
      ? filters.numeroSolicitud.map((req) => ({
          id: req.id,
          nombre: req.nombre,
          tipoAsignacion: req.tipoAsignacion
        }))
      : [],
    posicionesLineas:
      filters?.posicionesLineas?.map((positionLine) => positionLine?.value.replace(/[PL]/g, '')) ??
      [],
    estadosSolicitud:
      !isPending && filters?.estadosSolicitud?.length
        ? filters?.estadosSolicitud.map((state) => ({
            id: state.id,
            nombre: state.nombre
          }))
        : []
  };

  return {
    filters: filtersWorkReport
  };
};
const mapFilterArray = (filterArray, key) =>
  filterArray?.length ? filterArray.map((item) => item[key]) : [];

const mapFilterId = (filter) => (filter ? filter.id : null);

export const buildFilterServiceRequest = (
  filters = null,
  paginationData = null,
  gridTab = null
) => {
  const filtersAfterSDS = {
    numeroSolicitudServicio: mapFilterArray(filters.numeroSolicitud, 'nombre'),
    ubicaciones: mapFilterArray(filters?.ubicacion, 'nombre'),
    tipoUbicacionEnum: mapFilterId(filters.tipoUbicacionEnum),
    fechaDesde: filters.fechaDesde || null,
    fechaHasta: filters.fechaHasta || null,
    servicioIds: mapFilterArray(filters?.idsServicios, 'id'),
    contratoIds: mapFilterArray(filters?.idsContratos, 'id'),
    proveedorIds: mapFilterArray(filters?.idsProveedores, 'id'),
    unidadesNegocioIds: mapFilterArray(filters?.unidadesNegocioIds, 'id'),
    operacionesIds: mapFilterArray(filters?.operacionesIds, 'id'),
    estadosEnums: mapFilterArray(filters?.estadosEnums, 'id'),
    equiposDeTorre: mapFilterArray(filters.equipo, 'id'),
    idUsuarioCreador: mapFilterId(filters.idUsuarioCreador),
    paginacion: paginationData,
    grillaAgrupadaEnum: gridTab,
    idPrioridad: mapFilterId(filters.idPrioridad),
    eventoIds: mapFilterArray(filters?.idEvento, 'id')
  };

  return {
    filtersAfterSDS
  };
};
